
import Hashids from 'hashids';

const hashids = new Hashids('', 10);

export const cipherID = (id) => {
  return hashids.encode(id);
};

export const decipherID = (string) => {
  const id = hashids.decode(string);
  if (id.length > 0) return id[0];
  return null;
};
